import { render, staticRenderFns } from "./categoryChartColumn.vue?vue&type=template&id=a228c5a8"
import script from "./categoryChartColumn.vue?vue&type=script&lang=js"
export * from "./categoryChartColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports